import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const AutoCompleteItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &>:nth-child(2) {
    font-weight: bold;
  }
`;
